import React, { useState } from "react";
import { Link } from "react-router-dom";
import { trackEvent, Card } from "@jsainsburyplc/id-ui-common";
import { Modal, ModalHeading } from "@sainsburys-tech/luna-modal";

import { getLoginLink, missionId } from "utils/urls";
import PageFormat from "components/PageFormat";
import { categoryTypes, actionTypes } from "constants/tracking";
import missionContent from "missionContent";

const trackLink = () => {
  trackEvent({
    category: categoryTypes.PROGRESSIVE_REGISTRATION,
    action: actionTypes.CLICK,
    label: `Continue to ${missionId} Login`,
  });
};

const trackHelpText = () => {
  trackEvent({
    category: categoryTypes.PROGRESSIVE_REGISTRATION,
    action: actionTypes.CLICK,
    label: `${missionId} help modal`,
  });
};

export const ProgressiveRegistration = (props) => {
  const [showHelpText, setShowHelpText] = useState(false);

  const handleViewHelpText = () => {
    trackHelpText();
    setShowHelpText(true);
  };

  const { title, copy, helpText } = missionContent.progressiveRegistration;

  return (
    <PageFormat>
      <div className="c-hero ln-u-margin-bottom*4">
        <h1 className="ln-u-h3">{title}</h1>
      </div>
      <Card>
        <div className="ln-u-margin-bottom*2">
          {copy.map((paragraph, i) => (
            <p key={`${missionId}-${i}`} className="ln-u-margin-bottom*2">
              {paragraph}
            </p>
          ))}
        </div>
        <Link
          data-testid="continue-to-login-button"
          onClick={trackLink}
          to={{ pathname: getLoginLink(), search: props.location.search }}
          style={{ maxWidth: "400px" }}
          className="ln-c-button ln-c-button--filled ln-c-button--full ln-u-margin-bottom*2"
        >
          Continue to log in
        </Link>
        {helpText && (
          <Link
            className="ln-c-link ln-c-link--bare ln-c-link--cta"
            data-testid="show-help-text"
            onClick={handleViewHelpText}
            to="#"
          >
            {helpText}
          </Link>
        )}
      </Card>
      {helpText && (
        <Modal
          small
          handleClose={() => setShowHelpText(false)}
          open={showHelpText}
          headingId="info-modal"
          role="dialog"
          id="info-modal"
          title="Haven’t registered with Nectar before?"
        >
          <ModalHeading element="h5">
            Haven’t registered with Nectar before?
          </ModalHeading>
          <p>
            You may have previously created a My ID account by signing up for
            Sainsbury's and not completing the registration.
          </p>
          <p>
            This might have happened if you started registering for Sainsbury’s
            but we couldn’t deliver to your area.
          </p>
        </Modal>
      )}
    </PageFormat>
  );
};
